<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h1>Relatórios</h1>
      </div>
    </div>
    <v-card width="100%">
      <v-card-title>Contatos realizados por mês</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="4">
            <v-select
              label="Mês"
              v-model="month"
              :items="months"
              item-text="text"
              item-value="value"
              outlined
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" sm="4">
            <v-select
              label="Ano"
              v-model="year"
              :items="years"
              outlined
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" sm="4">
            <v-btn color="primary" @click="load()" block>Gerar</v-btn>
          </v-col>
        </v-row>
        <div v-if="report">
          <v-alert dense text type="info">
            {{ report.total }} contatos realizados em
            {{ monthName(report.month) }}/{{ report.year }}
          </v-alert>
          <v-row>
            <v-col cols="12" md="6">
              <v-simple-table>
                <thead>
                  <tr>
                    <th>Tipo de Contato</th>
                    <th>Quantidade</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in report.types" :key="item.typeId">
                    <td>{{ item.typeName }}</td>
                    <td>{{ item.count }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col cols="12" md="6" v-if="report.statuses">
              <v-simple-table>
                <thead>
                  <tr>
                    <th>Status</th>
                    <th>Quantidade</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in report.statuses" :key="item.status">
                    <td>
                      <v-btn x-small v-bind:color="colorStatus(item.status)">{{
                        item.status | formatStatus
                      }}</v-btn>
                    </td>
                    <td>{{ item.count }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-alert dense text type="warning" v-if="report.statuses">
            {{ billable }} contatos para faturamento no mês
          </v-alert>
        </div>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../api/index.js";
export default {
  data: function () {
    return {
      report: null,
      month: null,
      year: null,
      years: [],
      months: [
        { text: "Janeiro", value: 1 },
        { text: "Fevereiro", value: 2 },
        { text: "Março", value: 3 },
        { text: "Abril", value: 4 },
        { text: "Maio", value: 5 },
        { text: "Junho", value: 6 },
        { text: "Julho", value: 7 },
        { text: "Agosto", value: 8 },
        { text: "Setembro", value: 9 },
        { text: "Outubro", value: 10 },
        { text: "Novembro", value: 11 },
        { text: "Dezembro", value: 12 },
      ],
      dialog_loading: false,
    };
  },
  created: function () {
    var now = new Date();
    this.year = now.getFullYear();
    this.month = now.getMonth() + 1;
    for (var i = 0; i < 5; i++) {
      this.years.push(now.getFullYear() - i);
    }
    this.load();
  },
  computed: {
    billable: function () {
      if (!this.report || !this.report.statuses) {
        return 0;
      }
      return this.report.statuses.reduce(function (total, item) {
        return item.status == 1 || item.status == 4
          ? total
          : total + item.count;
      }, 0);
    },
  },
  methods: {
    monthName: function (value) {
      var found = this.months.find(function (m) {
        return m.value === value;
      });
      return found ? found.text : value;
    },
    colorStatus: function (status) {
      var ret = "default";
      if (status == 1) {
        ret = "primary";
      } else if (status == 2) {
        ret = "success";
      } else if (status == 3) {
        ret = "warning";
      } else if (status == 4) {
        ret = "error";
      }
      return ret;
    },
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/contact/done/count/" + this.year + "/" + this.month, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.report = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao gerar relatório!");
        });
    },
  },
  filters: {
    formatStatus: function (value) {
      var ret = "desconhecido";
      if (value == 1) {
        ret = "Agendada";
      } else if (value == 2) {
        ret = "Atendida";
      } else if (value == 3) {
        ret = "Não atendida";
      } else if (value == 4) {
        ret = "Não existe";
      }
      return ret;
    },
  },
};
</script>
